/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'GoalLinker.error.generic.description': 'Kontrollér din internetforbindelse, og prøv igen.',
  'GoalLinker.error.generic.header': 'Noget gik galt',
  'GoalLinker.error.linking.header': 'Målet kunne ikke tilknyttes',
  'GoalLinker.error.max-entities-to-goal.description':
    'Der kan maksimalt tilknyttes 100 {entities} til et mål. Fjern 1 {entity}, hvis du vil tilknytte flere {entities}.',
  'GoalLinker.error.max-entities-to-goal.header': 'Grænsen på 100 {entity} er nået',
  'GoalLinker.error.max-goals.description':
    'Du kan maksimalt tilknytte 100 mål. Fjern tilknyttede mål, hvis du ønsker at tilknytte yderligere mål.',
  'GoalLinker.error.max-goals.header': 'Grænsen på 100 mål er nået',
  'GoalLinker.goal-row.open-goal': 'Åbn mål',
  'GoalLinker.link-goals.error-description': 'Der gik noget galt. Kontrollér din internetforbindelse, og prøv igen.',
  'GoalLinker.link-goals.error-title': 'Tilknytningen af målet kunne ikke fjernes',
  'GoalLinker.linked-goals.header': 'Tilknyttede mål',
  'GoalLinker.linked-goals.show-less': 'Vis mindre',
  'GoalLinker.linked-goals.show-more': 'Vis yderligere {count}',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Knyt idéer til mål for at følge, hvordan sager bidrager til resultater',
  'GoalLinker.recents.emptystate-project.description':
    'Knyt dine projekter til mål for at følge, hvordan sager udvikler sig til resultater',
  'GoalLinker.recents.emptystate.description':
    'Knyt dine sager til mål for at følge, hvordan sager udvikler sig til resultater',
  'GoalLinker.recents.emptystate.header': 'Kom i gang med mål',
  'GoalLinker.recents.header': 'Seneste mål',
  'GoalLinker.search.emptystate.description': 'Tjek, om der er stavefejl',
  'GoalLinker.search.emptystate.header': 'Ingen matchende resultater',
  'GoalLinker.search.label': 'Resultater',
  'GoalLinker.search.placeholder': 'Søg efter mål, eller indsæt link',
};
